import React from "react";
const ZWSP = "\u200B";
const InlineCenter = ({ children, disabled = false }) => disabled ? children : /* @__PURE__ */ React.createElement("span", {
  style: { display: "inline-flex", alignItems: "center" }
}, ZWSP, children);
var react_inline_center_default = InlineCenter;
export {
  react_inline_center_default as default
};
